import { privateChatMessageHolder } from "../../../components/PrivateChatMessageHolder";
import { isMobile } from "react-device-detect";
import { changeMatchmakingTab } from "./matchmaking";
import { possibleTabs } from "../reducers/matchmaking";
import { changeFriendTab, friendStates } from "./chat";

export const UPDATE_DISPLAYED_PRIVATE_CHAT_ORDER = 'UPDATE_DISPLAYED_PRIVATE_CHAT_ORDER';
export const HAS_NEW_PRIVATE_MESSAGE = 'HAS_NEW_PRIVATE_MESSAGE';
export const LOADED_PRIVATE_CHAT_PAGE = 'LOADED_PRIVATE_CHAT_PAGE';

export const CHANGED_OPEN_PRIVATE_CHAT = 'CHANGED_OPEN_PRIVATE_CHAT';
export const PRIVATE_CHAT_LISTS_UPDATED = 'PRIVATE_CHAT_LISTS_UPDATED';

export const UNREAD_PRIVATE_MESSAGES_CHANGED = 'UNREAD_PRIVATE_MESSAGES_CHANGED';
export const SET_HOVERED_PRIVATE_CHAT = 'SET_HOVERED_PRIVATE_CHAT';

export const FRIEND_LIST_UPDATED = 'FRIEND_LIST_UPDATED';

export const friendListUpdated = () => (dispatch, getState) => {
	const userFriendList = {};

	myUser.friends.list.forEach((value, playerId) => {
		userFriendList[playerId] = value.isOnline();
	});
	const currentDisplayedList = getState().privateChat.displayedFriendList;

	if(!_.isEqual(userFriendList, currentDisplayedList)) {
		dispatch({
			type: FRIEND_LIST_UPDATED,
			payload: userFriendList,
		});
	}
};

export const setHoveredPrivateChatId = (id, hovered) => {

	return {
		type: SET_HOVERED_PRIVATE_CHAT,
		payload: {
			hovered,
			id: id,
		}
	};
};
export const unreadPrivateMessagesChanged = (count) => (dispatch, getState) => {
	const state = getState();
	if(count === state.privateChat.unreadPrivateMessageCount) {
		return;
	}
	dispatch({
		type: UNREAD_PRIVATE_MESSAGES_CHANGED,
		payload: count
	});
};

export const setCurrentOpenPrivateChat = (id) => (dispatch, getState) => {
	if(isMobile) {
		dispatch(changeMatchmakingTab(possibleTabs.friends));
	}
	dispatch(changeFriendTab(friendStates.messages));
	dispatch({
		type: CHANGED_OPEN_PRIVATE_CHAT,
		payload: id,
	});
};

export const privateChatListUpdate = (openChats, closedChats) => (dispatch, getState) => {
	const state = getState();
	const { openPrivateChats, closedPrivateChats } = state.chat;

	const openChatKeys = {};
	const closedChatKeys = {};
	for(let key of openChats.keys()) {
		openChatKeys[key] = true;
	}
	for(let key of closedChats.keys()) {
		closedChatKeys[key] = true;
	}

	if(_.isEqual(openChatKeys, openPrivateChats) && _.isEqual(closedChatKeys, closedPrivateChats)) {
		return;
	}
	dispatch({
		type: PRIVATE_CHAT_LISTS_UPDATED,
		payload: {
			openPrivateChats: openChatKeys,
			closedPrivateChats: closedChatKeys,
		}
	});
};

// total: how many open conversations the server has, or null when the page didn't say.
export const loadedPrivateChatPage = (page, hasMore, total = null) => {
	return {
		type: LOADED_PRIVATE_CHAT_PAGE,
		payload: {
			page,
			hasMore,
			total,
		},
	};
};

export const checkPrivateChatDisplayOrder = (id) => (dispatch, getState) => {
	const state = getState();
	const { displayedPrivateMessages } = state;

	const sortedChatsMap = privateChatMessageHolder.sortedChatsById();
	const sortedChatList = [];
	sortedChatsMap.forEach((chat) => {
		sortedChatList.push(chat[0]);
	});

	dispatch({
		type: HAS_NEW_PRIVATE_MESSAGE,
	});
	if(_.isEqual(sortedChatsMap, displayedPrivateMessages)) {
		return;
	}
	dispatch({
		type: UPDATE_DISPLAYED_PRIVATE_CHAT_ORDER,
		payload: sortedChatList
	});
};